<template>
  <div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>招商管理</el-breadcrumb-item>
      <el-breadcrumb-item>客户管理</el-breadcrumb-item>
    </el-breadcrumb> -->

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div  slot="header" class="flexContainer">
        <span  class="cardHeader">客户管理</span>
        <div style="float:right;">
          <el-checkbox v-model="tableDrag" style="margin-right:15px">表格拖拽</el-checkbox>
          <el-button type="warning" icon="el-icon-warning-outline" size="normal" @click="complianceDialogVisible = true">合规检测</el-button>
          <el-button type="primary" icon="el-icon-user" size="normal" @click="createCustomerClickHandler">成交客户</el-button>
        </div>

      </div>

      <!-- Tabs区域 -->
      <el-tabs v-model="activeTab" type="border-card" class="no-padding" @tab-click="handleTabClick">

        <!-- 客户列表Tab -->
        <el-tab-pane label="客户列表" name="customer">
          <!-- 搜索条 -->
          <div class="search-bar">
            <el-form :model="customerQueryInfo" :inline="true" size="small" label-width="80px">
              <el-form-item label="客户信息">
                <el-input clearable v-model="customerQueryInfo.query" placeholder="名称、联系人姓名或手机号" @clear="getCustomerList" @keyup.enter.native="getCustomerList"></el-input>
              </el-form-item>
              <el-form-item label="客户来源">
                <el-select v-model="customerQueryInfo.from" placeholder="来源" clearable style="width:150px" @change="getCustomerList">
                  <el-option v-for="item in fromList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="创建时间">
                <el-date-picker clearable
                  style="width:300px"
                  v-model="customerQueryInfo.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getCustomerList">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="创建人">
                <el-select v-model="customerQueryInfo.creatorId" placeholder="创建人" clearable style="width:150px" @change="getCustomerList">
                  <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getCustomerList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetCustomerQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 表格区域 -->
          <el-table ref="customerTable" v-drag-scroll="tableDrag" :data="customerList" style="margin-top:0px" height="calc(100vh - 380px)" border>
            <el-table-column label="编号" type="index" width="50px" align="center" fixed="left"></el-table-column>

            <el-table-column label="客户信息" min-width="200px" fixed="left">
              <template slot-scope="scope">
                <div class="text-title">{{scope.row.title}}</div>
                <div class="text-detail">{{scope.row.name}} | {{scope.row.mobile}}</div>
              </template>
            </el-table-column>

            <el-table-column label="创建人" width="70px">
              <template slot-scope="scope">
                <el-link style="font-size: 12px;" type="primary" @click="filterByCreator(scope.row)">{{scope.row.creatorName}}</el-link>
              </template>
            </el-table-column>

            <el-table-column label="创建时间" width="140px">
              <template slot-scope="scope">
                <div class="text-content">{{scope.row.createDate|dateFormat}}</div>
              </template>
            </el-table-column>

            <el-table-column label="来源" width="80px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.from }}</div>
              </template>
            </el-table-column>

            <el-table-column label="成交项目" width="200px" >
              <template slot-scope="scope">
                <div v-if="scope.row.projectsData.length>0">
                  <div v-for="(project) in scope.row.projectsData" :key="project._id">
                    <el-link  class="text-content" type="primary" style="cursor:pointer" @click="filterByProject(project)">{{ project.projectName }}</el-link>
                    <el-tooltip v-if="project.transferOutInfo && project.transferOutInfo.toProjectId" placement="top" :content="transferOutTooltip(project.transferOutInfo)">
                      <el-tag size="mini" type="warning" style="margin-left:4px;">已转让</el-tag>
                    </el-tooltip>
                  </div>
                </div>
                <div class="text-detail" v-else>无</div>
              </template>
            </el-table-column>

            <el-table-column label="客户微信" width="180px">
              <template slot-scope="scope">
                <div v-if="scope.row.customerWechat" style="display: flex; align-items: center;">
                  <img :src="scope.row.customerWechat.avatar" alt="微信头像" style="width: 30px; height: 30px; border-radius: 50%; margin-right: 10px;">
                  <div>
                    <div class="text-content">{{ scope.row.customerWechat.nickname }}</div>
                    <div class="text-detail">{{ scope.row.customerWechat.alias }}</div>
                  </div>
                </div>
                <div v-else>
                  <el-link type="primary" :underline="true" icon="el-icon-link" style="font-size: 12px;" @click="modifyClickHandler(scope.row)">绑定微信</el-link>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="员工微信" width="230px">
              <template slot-scope="scope">
                <div v-if="scope.row.creatorWechat" style="display: flex; align-items: center;">
                  <img :src="scope.row.creatorWechat.avatar" alt="微信头像" style="width: 30px; height: 30px; border-radius: 50%; margin-right: 10px;">
                  <div>
                    <div class="text-content">{{ scope.row.creatorWechat.nickname }}</div>
                    <div class="text-detail">{{ scope.row.creatorWechat.alias }}</div>
                  </div>
                </div>
                <div v-else>
                  <el-link type="primary" :underline="true" icon="el-icon-link" style="font-size: 12px;" @click="modifyClickHandler(scope.row)">绑定微信</el-link>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="备注" min-width="200px">
              <template slot-scope="scope">
                <div v-if="scope.row.remark" class="text-content">{{ scope.row.remark }}</div>
                <div v-else class="text-content">无</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="250px" fixed="right">
              <template slot="header">
                <div class="table-header-with-arrows">
                  <span>操作</span>
                  <div class="arrow-buttons">
                    <i class="el-icon-back" @click="scrollTable('customerTable', -200)"></i>
                    <i class="el-icon-right" @click="scrollTable('customerTable', 200)"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="createProjectClickHandler(scope.row)">成交新项目</el-button>
                <el-button type="primary" plain size="mini" @click="modifyClickHandler(scope.row)">修改</el-button>
                <el-button type="danger" :disabled="!finCan('删除客户')" plain size="mini" @click="deleteClickHandler(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页区域 -->
          <el-pagination style="margin-top:10px;margin-bottom: 10px;padding-left:20px"
            @size-change="customerHandleSizeChange"
            @current-change="customerHandleCurrentChange"
            :current-page="customerQueryInfo.pagenum"
            :page-sizes="[10,20,50]"
            :page-size="customerQueryInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="customerTotal"
          >
          </el-pagination>
        </el-tab-pane>

        <!-- 项目列表Tab -->
        <el-tab-pane label="项目列表" name="project">
          <!-- 搜索条 -->
          <div class="search-bar">
            <el-form :model="projectQueryInfo" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键词">
                <el-input clearable v-model="projectQueryInfo.keyword" placeholder="项目名称/客户名称" @clear="getProjectList" style="width:150px"  @keyup.enter.native="getProjectList"></el-input>
              </el-form-item>
              <el-form-item label="签约人">
                <el-select clearable v-model="projectQueryInfo.signerId" placeholder="请选择" @change="getProjectList" style="width:100px">
                  <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约类型">
                <el-select clearable v-model="projectQueryInfo.signType" placeholder="请选择" @change="getProjectList" style="width:100px">
                  <el-option v-for="(item, index) in signTypeList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约日期">
                <el-date-picker
                  style="width:260px"
                  v-model="projectQueryInfo.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getProjectList">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="移交状态">
                <el-select clearable v-model="projectQueryInfo.handoverStatus" placeholder="请选择" @change="getProjectList" style="width:120px">
                  <el-option label="未移交" value="0"></el-option>
                  <el-option label="已移交" value="1"></el-option>
                  <el-option label="已录入门店" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getProjectList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetProjectQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 表格区域 -->
          <el-table ref="projectTable" v-drag-scroll="tableDrag" :data="projectList" style="margin-top:0px" height="calc(100vh - 380px)" border>
            <el-table-column label="编号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="项目名称" min-width="200px" fixed="left">
              <template slot-scope="scope">
                <el-link class="bold" type="primary" @click="filterByProject(scope.row)">{{ scope.row.projectName}}</el-link>
                <el-tooltip v-if="scope.row.transferOutInfo && scope.row.transferOutInfo.toProjectId" placement="top" :content="transferOutTooltip(scope.row.transferOutInfo)">
                  <el-tag size="mini" type="warning" style="margin-left:4px;">已转让</el-tag>
                </el-tooltip>
                <!-- 客户年龄标签：无身份证=danger"无"，虚岁>45=warning，否则=success -->
                <div class="text-content">
                  <el-tag size="mini" style="margin-right:5px" :type="customerAgeTagType(scope.row.customerAge)">{{ customerAgeTagText(scope.row.customerAge) }}</el-tag>
                  {{ scope.row.customerName }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="签约类型" min-width="100px">
              <template slot-scope="scope">
                <div class="text-content">
                  {{ scope.row.signType }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="签约人" min-width="70px">
              <template slot-scope="scope">
                <el-link style="font-size: 12px;" type="primary" @click="filterByCreator(scope.row)">{{ scope.row.signerName }}</el-link>
              </template>
            </el-table-column>

            <el-table-column label="合同编号" min-width="150px">
              <template slot-scope="scope">
                <div v-for="(item) in scope.row.contracts" :key="item._id">
                  <el-link class="text-content" type="primary" :underline="false" style="font-size: 12px;" @click="filterContractByProject(scope.row)">合同：{{ item.contractNo }}</el-link>
                  <span v-if="item.status===-1 && item.rescindType==='transfer'" class="text-content" style="color:#E6A23C;">（已转让）</span>
                  <span v-else-if="item.status===-1" class="text-content red">（已解约）</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="签约日期" min-width="90px">
              <template slot-scope="scope">
                <div v-for="(item) in scope.row.contracts" :key="item._id" class="text-content">{{ item.signDate|date }}</div>
              </template>
            </el-table-column>

            <el-table-column label="合同金额" min-width="80px">
              <template slot-scope="scope">
                <div v-for="(item) in scope.row.contracts" :key="item._id" class="text-content bold black">￥{{ item.contractAmount }}</div>
              </template>
            </el-table-column>

            <el-table-column label="抽佣比例" min-width="70px">
              <template slot-scope="scope">
                <div v-for="(item) in scope.row.contracts" :key="item._id" class="text-content bold black">{{ item.commissionRate || 0 }}%</div>
              </template>
            </el-table-column>

            <el-table-column label="已收款" width="80px">
              <template slot-scope="scope">
                <div v-for="(item) in scope.row.contracts" :key="item._id">
                  <el-tag type="success" size="mini" class="text-content bold green">￥{{ item.receivedAmount }}</el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="退款" width="80px">
              <template slot-scope="scope">
                <!-- <el-tag type="info" effect="dark" size="mini" v-for="(item) in scope.row.contracts" :key="item._id" class="textel-ntent bold">￥{{ item.refundAmount }}</el-tag> -->
                <div v-for="(item) in scope.row.contracts" :key="item._id">
                  <el-tag v-if="item.refundAmount > 0" type="danger" size="mini" class="text-content bold red">-￥{{ item.refundAmount }}</el-tag>
                  <div v-else class="text-content">无</div>
                </div>

              </template>
            </el-table-column>

            <el-table-column label="督导" min-width="100px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.supervisorName || '未指定' }}</div>

              </template>
            </el-table-column>

            <el-table-column label="是否移交" min-width="100px">
              <template slot-scope="scope">
                <div v-if="scope.row.signType === '代运营'">
                  <el-tag v-if="!scope.row.proxyStatus" type="danger" size="mini">未移交</el-tag>
                  <el-tag v-else-if="scope.row.proxyStatus === 'PENDING'" type="warning" size="mini">待接收</el-tag>
                  <el-tag v-else type="primary" size="mini">已接收</el-tag>
                </div>
                <div v-else-if="scope.row.signType === '其他'">
                  <el-tag type="info" size="mini">无需移交</el-tag>
                </div>
                <div v-else-if="scope.row.handoverStatus === 0 && scope.row.hasStore">
                  <el-tag type="info" size="mini">已录入门店</el-tag>
                </div>
                <div v-else-if="scope.row.handoverStatus === 0">
                  <el-tag type="danger" size="mini">未移交</el-tag>
                </div>
                <div v-else-if="scope.row.handoverStatus === 1||scope.row.handoverStatus === 2">
                  <el-tag type="primary" size="mini">已移交</el-tag>
                </div>
                <!-- 本列主要显示移交督导后的状态，已解约和已完成都算是已移交 -->
                <div v-else-if="scope.row.handoverStatus === 3">
                  <el-tag type="info" size="mini">已移交</el-tag>
                </div>
                <div v-else-if="scope.row.handoverStatus === 4">
                  <el-tag type="success" size="mini">已移交</el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="附加信息" min-width="140px">
              <template slot-scope="scope">
                <el-tooltip placement="left">
                  <div slot="content">
                    <div v-if="scope.row.additionalInfo && Object.keys(scope.row.additionalInfo).length > 0">
                      <div v-for="(value, key) in scope.row.additionalInfo" :key="key" style="line-height: 1.8;">
                        <span>{{ key }}:</span> <span v-html="getMultLine(value)"></span>
                      </div>
                    </div>
                    <div v-else>无</div>
                  </div>
                  <el-button type="text" size="small">查看详情</el-button>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="备注" prop="remark" min-width="200px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.remark || '无' }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" :min-width="300" fixed="right">
              <template slot="header">
                <div class="table-header-with-arrows">
                  <span>操作</span>
                  <div class="arrow-buttons">
                    <i class="el-icon-back" @click="scrollTable('projectTable', -200)"></i>
                    <i class="el-icon-right" @click="scrollTable('projectTable', 200)"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
              <div>
                  <div style="margin-bottom: 10px;">
                    <el-button type="primary" plain size="mini" :disabled="scope.row.signType === '其他' || isTransferredOldProject(scope.row)" @click="createAddReIncomeHandler(scope.row)">续签</el-button>
                    <el-button v-if="!isTransferredOldProject(scope.row)" type="primary" plain size="mini" @click="modifyProjectClickHandler(scope.row)">修改</el-button>
                    <el-button v-else type="primary" plain size="mini" @click="modifyTransferRemarkHandler(scope.row)">修改备注</el-button>
                    <el-button type="danger" :disabled="!finCan('删除项目') || scope.row.handoverStatus>=1||isTransferredOldProject(scope.row)||isTransferredInProject(scope.row)" plain size="mini" @click="deleteProjectClickHandler(scope.row)">删除</el-button>
                  </div>
                  <div style="margin-top: 10px;">
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      :disabled="getHandoverDisabled(scope.row)"
                      @click="handoverProjectClickHandler(scope.row)">
                      项目移交
                    </el-button>
                    <el-button
                      type="warning"
                      plain
                      size="mini"
                      :disabled="getCancelHandoverDisabled(scope.row)"
                      @click="cancelHandoverClickHandler(scope.row)">
                      撤回移交
                    </el-button>
                    <el-button
                      type="success"
                      plain
                      size="mini"
                      :disabled="getTransferDisabled(scope.row)"
                      :loading="transferCheckingId === scope.row._id"
                      @click="transferProjectClickHandler(scope.row)">
                      转让
                    </el-button>
                  </div>
                </div>

              </template>
            </el-table-column>
          </el-table>

          <!-- 分页区域 -->
          <el-pagination style="margin-top:10px;margin-bottom: 10px;padding-left:20px"
            @size-change="projectHandleSizeChange"
            @current-change="projectHandleCurrentChange"
            :current-page="projectQueryInfo.pagenum"
            :page-sizes="[10,20,50]"
            :page-size="projectQueryInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="projectTotal"
          >
          </el-pagination>
        </el-tab-pane>

        <!-- 合同列表Tab -->
        <el-tab-pane label="合同列表" name="contract">

          <!-- 搜索条 -->
          <div class="search-bar">
            <el-form :model="contractQueryInfo" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键词">
                <el-input clearable v-model="contractQueryInfo.keyword" placeholder="项目名称/客户名称" @clear="getContractList" style="width:170px"  @keyup.enter.native="getContractList"></el-input>
              </el-form-item>
              <el-form-item label="签约人">
                <el-select clearable v-model="contractQueryInfo.signerId" placeholder="请选择" @change="getContractList" style="width:100px">
                  <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约类型">
                <el-select clearable v-model="contractQueryInfo.signType" placeholder="请选择" @change="getContractList" style="width:120px">
                  <el-option v-for="(item, index) in signTypeList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同类型">
                <el-select clearable v-model="contractQueryInfo.contractType" placeholder="请选择" @change="getContractList" style="width:100px">
                  <el-option label="新签" :value="1"></el-option>
                  <el-option label="续签" :value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="合同状态">
                <el-select clearable v-model="contractQueryInfo.status" placeholder="请选择" @change="getContractList" style="width:100px">
                  <el-option label="正常" :value="0"></el-option>
                  <el-option label="解约" :value="-1"></el-option>
                  <el-option label="已转让" value="transfer"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约日期">
                <el-date-picker
                  style="width:260px"
                  v-model="contractQueryInfo.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getContractList">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getContractList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetContractQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <el-table ref="contractTable" v-drag-scroll="tableDrag" :data="contractList" style="margin-top:0px" height="calc(100vh - 380px)" border>
            <el-table-column label="编号" type="index" width="50px" align="center" fixed="left"></el-table-column>
            <el-table-column label="合同/客户" min-width="200px" fixed="left">
              <template slot-scope="scope">
                <el-link class="bold" type="primary" @click="filterByProject(scope.row)">{{ scope.row.projectName}}</el-link>
                <div class="text-content" type="primary">
                  {{ scope.row.contractNo }}
                </div>
                <div v-if="scope.row.status===-1 && scope.row.rescindType==='transfer'" class="text-content" style="color:#E6A23C;"><i class="el-icon-refresh"></i>已转让</div>
                <div v-else-if="scope.row.status===-1" class="text-content red"><i class="el-icon-warning-outline"></i>已解约</div>
              </template>
            </el-table-column>

            <el-table-column label="合同类型" width="80px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.contractType===1?'新签':'续签' }}</div>
              </template>
            </el-table-column>

            <el-table-column label="签约人" width="80px">
              <template slot-scope="scope">
                <el-link style="font-size: 12px" type="primary" @click="filterByCreator(scope.row)">{{ scope.row.signerName }}</el-link>
              </template>
            </el-table-column>

            <el-table-column label="签约类型" width="80px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.signType }}</div>
              </template>
            </el-table-column>

            <el-table-column label="签约日期" width="90px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.signDate|date }}</div>
              </template>
            </el-table-column>

            <el-table-column label="合同金额" width="80px">
              <template slot-scope="scope">
                <div class="text-content bold black">￥{{ scope.row.contractAmount }}</div>
              </template>
            </el-table-column>

            <el-table-column label="抽佣比例" width="80px">
              <template slot-scope="scope">
                <div class="text-content bold black">{{ scope.row.commissionRate || 0 }}%</div>
              </template>
            </el-table-column>

            <el-table-column label="财务记录" width="120px">
              <template slot-scope="scope">
                <div v-for="item in scope.row.bills" :key="item._id">
                  <el-tag size="mini" :type="item.type===1?'success':'danger'">
                    <span v-if="item.type===1">{{ item.payType }}:￥{{ item.totalAmount }}</span>
                    <span v-else>{{ item.payType }}:-￥{{ item.totalAmount }}</span>
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="服务时间" width="160px">
              <template slot-scope="scope">
                <div class="text-content">开始时间：{{ scope.row.serviceStartDate?$getDate(scope.row.serviceStartDate):'-' }}</div>
                <div class="text-content">结束时间：{{ scope.row.serviceEndDate?$getDate(scope.row.serviceEndDate):'-' }}</div>
              </template>
            </el-table-column>

            <!-- <el-table-column label="合同状态" width="80px">
              <template slot-scope="scope">
                <div v-if="scope.row.status===0" class="text-content">服务中</div>
                <div v-else class="text-content red">已解约</div>
              </template>
            </el-table-column> -->

            <el-table-column label="合同备注" width="200px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.remark }}</div>
              </template>
            </el-table-column>

            <el-table-column label="解约/转让信息" width="250px">
              <template slot-scope="scope">
                <div v-if="scope.row.rescindDate" class="text-content">
                  {{ scope.row.rescindDate|date }}
                  {{ scope.row.rescindType === 'transfer' ? '转让' : '解约' }}，扣管理费￥{{ scope.row.rescindFee }}
                </div>
                <div v-if="scope.row.rescindType === 'transfer' && scope.row.transferToProjectName" class="text-content">
                  转让至：{{ scope.row.transferToCustomerName || '-' }} / {{ scope.row.transferToProjectName }}
                </div>
                <div v-if="scope.row.rescindReason" class="text-content">{{ scope.row.rescindReason }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="280px" fixed="right">
              <template slot="header">
                <div class="table-header-with-arrows">
                  <span>操作</span>
                  <div class="arrow-buttons">
                    <i class="el-icon-back" @click="scrollTable('contractTable', -200)"></i>
                    <i class="el-icon-right" @click="scrollTable('contractTable', 200)"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
                <div>
                  <el-button type="primary" plain size="mini" :disabled="scope.row.status === -1" @click="createAddIncomeHandler(scope.row)">尾款</el-button>
                  <el-button type="primary" plain size="mini" :disabled="scope.row.signType === '其他' || scope.row.status === -1" @click="createAddRefundHandler(scope.row)">解约</el-button>
                  <el-button type="primary" plain size="mini" :disabled="scope.row.status === -1" @click="modifyContract(scope.row)">修改</el-button>
                  <el-button type="danger" :disabled="!finCan('删除合同') || scope.row.rescindType === 'transfer'" plain size="mini" @click="deleteContract(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>

          </el-table>

          <!-- 分页区域 -->
          <el-pagination style="margin-top:10px;margin-bottom: 10px;padding-left:20px"
            @size-change="contractHandleSizeChange"
            @current-change="contractHandleCurrentChange"
            :current-page="contractQueryInfo.pagenum"
            :page-sizes="[10,20,50]"
            :page-size="contractQueryInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="contractTotal"
          >
          </el-pagination>
        </el-tab-pane>

        <!-- 财务列表Tab -->
        <el-tab-pane label="财务列表" name="financial">

          <!-- 搜索条 -->
          <div class="search-bar">
            <el-form :model="financialQueryInfo" :inline="true" size="small" label-width="80px">
              <el-form-item label="关键词">
                <el-input clearable v-model="financialQueryInfo.keyword" placeholder="客户/项目" @clear="getFinancialList" style="width:120px" @keyup.enter.native="getFinancialList"></el-input>
              </el-form-item>
              <el-form-item label="收支类型">
                <el-select clearable v-model="financialQueryInfo.type" placeholder="请选择" @change="getFinancialList" style="width:120px">
                  <el-option label="收入" :value="1"></el-option>
                  <el-option label="支出" :value="-1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="钱款类型">
                <el-select clearable multiple v-model="financialQueryInfo.payType" placeholder="请选择" @change="getFinancialList" style="width:250px">
                  <el-option v-for="item in payTypeList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收支分类">
                <el-select clearable v-model="financialQueryInfo.feeType" placeholder="请选择" @change="getFinancialList" style="width:120px">
                  <el-option v-for="item in feeTypeList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收款账户">
                <el-select clearable v-model="financialQueryInfo.payAccount" placeholder="请选择" @change="getFinancialList" style="width:120px">
                  <el-option v-for="item in payAccountList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="审核状态">
                <el-select clearable v-model="financialQueryInfo.status" placeholder="请选择" @change="getFinancialList" style="width:120px">
                  <el-option label="未审核" :value="0"></el-option>
                  <el-option label="已审核" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="签约人">
                <el-select clearable v-model="financialQueryInfo.signerId" placeholder="请选择" @change="getFinancialList" style="width:150px">
                  <el-option v-for="item in employeeList" :key="item._id" :label="item.name" :value="item._id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收款日期">
                <el-date-picker
                  v-model="financialQueryInfo.dateArray"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getFinancialList">
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="getFinancialList(true)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetFinancialQuery">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 表格区域 -->
          <el-table ref="financialTable" v-drag-scroll="tableDrag" height="calc(100vh - 420px)" :data="financialList" style="margin-top:0px" border :row-class-name="financialRowClassName">

            <el-table-column label="编号" type="index" width="50px" align="center" fixed="left"></el-table-column>

            <!-- 审核状态 -->
            <el-table-column label="审核状态" width="50px" align="center">
              <template slot-scope="scope">
                <i class="el-icon-success" v-if="scope.row.status === 1" style="color: #67C23A;font-size:28px"></i>
                <i class="el-icon-remove" v-else style="color: #E6A23C;font-size:28px"></i>
              </template>
            </el-table-column>

            <el-table-column label="客户/合同" width="200px">
              <template slot-scope="scope">
                <el-link class="text-title" type="primary" @click="filterByProject(scope.row)">{{ scope.row.projectName }}</el-link>
                <div class="text-content">{{ scope.row.contractNo }}<span v-if="scope.row.contractStatus===-1 && scope.row.contractRescindType==='transfer'" class="text-content" style="color:#E6A23C;">（已转让）</span><span v-else-if="scope.row.contractStatus===-1" class="text-content red">（已解约）</span></div>
              </template>
            </el-table-column>

            <!-- 收支金额 -->
            <el-table-column label="收支金额" prop="totalAmount" width="150px">

              <template slot-scope="scope">
                <div class="text-content" :title="complianceTitle(scope.row)">
                  <el-tag :type="scope.row.type === 1 ? 'success' : 'danger'" size="small">
                    {{ scope.row.type === 1 ? '收款：' : '退款：' }} ¥ {{ scope.row.totalAmount }} 元
                  </el-tag>
                </div>
              </template>
            </el-table-column>

            <!-- 收款日期 -->
            <el-table-column label="收款日期" width="100px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.payDate|date }}</div>
              </template>
            </el-table-column>

            <!-- 签约人 -->
            <el-table-column label="签约人" width="80px">
              <template slot-scope="scope">
                <el-link style="font-size: 12px;" type="primary" @click="filterByCreator(scope.row)">{{ scope.row.receiverName }}</el-link>
              </template>
            </el-table-column>

            <!-- 钱款类型 -->
            <el-table-column label="钱款类型" width="100px">
              <template slot-scope="scope">
                <div class="text-content">
                  {{scope.row.payType}}
                </div>
              </template>
            </el-table-column>

            <!-- 收支分类 -->
            <el-table-column label="渠道来源" width="100px">
              <template slot-scope="scope">
                <div class="text-content">
                  {{scope.row.feeType}}
                </div>
              </template>
            </el-table-column>

            <!-- 收款账户 -->
            <el-table-column label="收款账户" width="150px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.payAccount }}</div>
              </template>
            </el-table-column>

            <!-- 附件 -->
            <el-table-column label="附件" width="200px">
              <template slot-scope="scope">
                <div v-if="scope.row.attachments && scope.row.attachments.length > 0" style="display: flex; gap: 5px; flex-wrap: wrap;">
                  <div v-for="(file, index) in scope.row.attachments" :key="index" @click="handlePreviewAttachment(file)" style="cursor: pointer;">
                    <img v-if="file.type === 'image'" :src="getFileUrl(file.url)" alt="附件" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px; border: 1px solid #dcdfe6;" />
                    <img v-else-if="file.type === 'pdf'" :src="pdfIconUrl" alt="PDF" style="width: 40px; height: 40px; object-fit: contain; border-radius: 4px; border: 1px solid #dcdfe6;" />
                    <i v-else class="el-icon-document" style="font-size: 40px; color: #909399;"></i>
                  </div>
                </div>
                <div v-else class="text-content">无</div>
              </template>
            </el-table-column>

            <el-table-column label="备注" min-width="300px">
              <template slot-scope="scope">
                <div class="text-content">{{ scope.row.remark || '无' }}</div>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="225px" fixed="right">
              <template slot="header">
                <div class="table-header-with-arrows">
                  <span>操作</span>
                  <div class="arrow-buttons">
                    <i class="el-icon-back" @click="scrollTable('financialTable', -200)"></i>
                    <i class="el-icon-right" @click="scrollTable('financialTable', 200)"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
                <el-button type="primary" :disabled="scope.row.status === 1 || !finCan(scope.row.type === -1 ? '修改退款' : '修改收款')" plain size="mini" @click="modifyFinancialClickHandler(scope.row)">修改</el-button>
                <el-button type="warning" :disabled="scope.row.status === 1 || !finCan('修改金额')" plain size="mini" @click="openAmountDialog(scope.row)">改金额</el-button>
                <el-button type="danger" :disabled="scope.row.status === 1 || !finCan('财务删除')" plain size="mini" @click="deleteFinancialClickHandler(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页区域 -->
           <div class="page-area">
            <div class="summary-text">总收款 {{ financialSummary.incomeCount }} 笔，共 ￥{{ formatMoney(financialSummary.incomeAmount) }} 元。 总退款 {{ financialSummary.refundCount }} 笔，共 ￥-{{ formatMoney(financialSummary.refundAmount) }} 元。</div>
            <div>
              <el-pagination
                @size-change="financialHandleSizeChange"
                @current-change="financialHandleCurrentChange"
                :current-page="financialQueryInfo.pagenum"
                :page-sizes="[10,20,50,100]"
                :page-size="financialQueryInfo.pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="financialTotal"
              >
              </el-pagination>
            </div>
           </div>

        </el-tab-pane>
      </el-tabs>
    </el-card>

    <!-- PDF预览对话框 -->
    <el-dialog :visible.sync="pdfPreviewDialogVisible" width="60%" :title="previewTitle">
      <div class="preview-container" style="height: 600px;">
        <iframe :src="previewUrl" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </el-dialog>

    <!-- 移交对话框 -->
    <el-dialog title="项目移交" :visible.sync="handoverDialogVisible" width="640px">
      <el-form :model="handoverForm" label-width="100px">
        <el-form-item label="项目名称">
          <span>{{ handoverForm.projectName }}</span>
        </el-form-item>

        <!-- 代运营项目：套餐类型 + 各平台评估单量 -->
        <template v-if="handoverFormSignType === '代运营'">
          <el-form-item label="套餐类型">
            <el-input v-model="handoverForm.packageType" placeholder="请输入运营套餐类型" style="width: 100%"></el-input>
          </el-form-item>
          <el-form-item label="评估单量">
            <div v-for="(v, idx) in handoverForm.estimatedVolumes" :key="idx" style="margin-bottom: 6px;">
              <el-tag size="mini" style="margin-right: 8px;">{{ platformName(v.platform) }}</el-tag>
              <el-input-number v-model="v.volume" :min="0" placeholder="日均单量" style="width: 180px"></el-input-number>
              <span style="margin-left: 6px; color: #909399; font-size: 12px;">单/天</span>
            </div>
          </el-form-item>
        </template>

        <!-- 品牌项目：原督导 + 企微群字段 -->
        <template v-else>
          <el-form-item label="接收督导">
            <span>{{ handoverForm.supervisorName }}</span>
          </el-form-item>
          <el-form-item label="企微群" required>
            <el-select
              v-model="handoverForm.conversationId"
              filterable
              remote
              reserve-keyword
              clearable
              placeholder="请输入群名称搜索"
              :remote-method="searchHandoverGroups"
              :loading="handoverGroupLoading"
              style="width: 100%"
              @change="onHandoverGroupChange">
              <el-option
                v-for="item in handoverGroupOptions"
                :key="item.conversation_id"
                :label="`${item.nickname}（${item.total}人）`"
                :value="item.conversation_id">
              </el-option>
            </el-select>
            <div v-if="handoverForm.currentBound" class="text-detail" style="margin-top:4px;color:#E6A23C;">该项目已绑定群，提交后将覆盖换绑</div>
          </el-form-item>
        </template>

        <el-form-item label="移交时间" required>
          <el-date-picker
            v-model="handoverForm.handoverAt"
            type="datetime"
            placeholder="选择移交时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handoverDialogVisible = false">取消</el-button>
        <el-button type="primary" :disabled="confirmHandoverDisabled" @click="confirmHandover">确认移交</el-button>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <!-- 修改金额对话框 -->
    <el-dialog title="修改收款金额" :visible.sync="amountDialogVisible" width="420px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="项目：">
          <span class="text-content">{{ amountForm.projectName }}</span>
        </el-form-item>
        <el-form-item label="原金额：">
          <span>¥ {{ formatMoney(amountForm.originalAmount) }} 元</span>
        </el-form-item>
        <el-form-item label="新金额：" required>
          <el-input-number v-model="amountForm.totalAmount" :min="0.01" :precision="2" :step="100" style="width: 220px"></el-input-number>
          <span style="margin-left: 8px">元</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="amountDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="amountSubmitting" @click="submitAmountModify">确定</el-button>
      </div>
    </el-dialog>

    <!-- 解约风险警告弹框（项目存在运营中门店时拦截） -->
    <el-dialog title="解约风险警告" :visible.sync="rescindWarnVisible" width="480px"
      :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="rescind-warn-dialog">
      <div class="rescind-warn-body">
        <i class="el-icon-warning rescind-warn-icon"></i>
        <div class="rescind-warn-text">
          此项目的店铺处于<b class="rescind-warn-strong">运营中</b>状态，建议先<b class="rescind-warn-strong">与运营师沟通一致</b>再操作
        </div>
        <div v-if="rescindStoreName" class="rescind-warn-store">运营中门店：{{ rescindStoreName }}</div>
      </div>
      <div slot="footer">
        <el-button type="danger" :disabled="rescindCountdown > 0" @click="confirmRescind">
          进入解约页面{{ rescindCountdown > 0 ? `（${rescindCountdown}s）` : '' }}
        </el-button>
        <el-button :disabled="rescindCountdown > 0" @click="closeRescindWarn">
          关闭{{ rescindCountdown > 0 ? `（${rescindCountdown}s）` : '' }}
        </el-button>
      </div>
    </el-dialog>

    <el-image
      v-show="false"
      ref="imageViewer"
      :src="currentImageUrl"
      :preview-src-list="imagePreviewList">
    </el-image>

    <!-- 附件合规检测弹框 -->
    <compliance-check-dialog :visible.sync="complianceDialogVisible" @project-click="filterByProject"></compliance-check-dialog>

  </div>
</template>

<script>
import { fromList, storeTypeList, payTypeList, feeTypeList, payAccountList } from '@/utility/staticData'
import { hasAction } from '@/utility/permissions'
import ComplianceCheckDialog from './components/ComplianceCheckDialog.vue'
export default {
  components: {
    ComplianceCheckDialog
  },
  data () {
    return {
      // 权限数据就位信号（Home 分发 grantedActions:ready 时自增，触发按钮显隐重算）
      grantedTick: 0,
      // 拖拽开关
      tableDrag: true,

      // 附件合规检测弹框
      complianceDialogVisible: false,

      // 转让预检进行中的项目ID（按钮 loading）
      transferCheckingId: '',

      // 当前账号信息
      accountInfo: {
        level: null,
        employeeId: '',
        employeeName: '',
        department: '',
        job: ''
      },

      // 当前激活的tab
      activeTab: 'customer',
      // 客户列表
      customerList: [],
      employeeList: [],
      fromList: fromList, // 客户来源
      signTypeList: storeTypeList, // 签约类型列表
      payTypeList: payTypeList, // 支付方式列表
      customerQueryInfo: {
        query: '', // 客户名称、联系人姓名或手机号关键字
        from: '', // 来源
        dateArray: [], // 日期范围
        creatorId: '', // 创建人ID
        pagenum: 1,
        pagesize: 10
      },
      customerTotal: 0,

      // 客户项目
      projectList: [],
      projectQueryInfo: {
        keyword: '', // 关键字（项目名称或客户名称）
        signType: '', // 签约类型
        signerId: '', // 签约人ID
        dateArray: [], // 签约日期范围
        handoverStatus: '', // 移交状态（0=未移交, 1=已移交）
        pagenum: 1,
        pagesize: 10
      },
      projectTotal: 0,

      // 合同列表
      contractList: [],
      contractQueryInfo: {
        keyword: '', // 关键字（项目名称或客户名称）
        signType: '', // 签约类型
        signerId: '', // 签约人ID
        dateArray: [], // 签约日期范围
        status: '', // 合同状态
        contractType: '', // 合同类型
        projectId: '', // 项目ID（点击合同编号快捷跳转时设置）
        pagenum: 1,
        pagesize: 10
      },
      contractTotal: 0,

      // 客户财务
      financialList: [],
      feeTypeList: feeTypeList,
      payAccountList: payAccountList,
      financialQueryInfo: {
        keyword: '', // 关键字（客户名称、项目名称）
        type: '', // 收支类型（-1=支出，1=收入）
        payType: [], // 钱款类型（改为数组支持多选）
        feeType: '', // 收支分类
        payAccount: '', // 收款账户
        status: '', // 审核状态（0=未审核，1=已审核）
        signerId: '', // 签约人ID
        dateArray: [], // 收款日期范围
        pagenum: 1,
        pagesize: 10
      },
      financialTotal: 0,
      financialSummary: {
        incomeCount: 0,
        incomeAmount: 0,
        refundCount: 0,
        refundAmount: 0
      },

      // PDF 图标路径
      pdfIconUrl: require('@/assets/pdf.png'),

      // 预览相关
      pdfPreviewDialogVisible: false,
      previewUrl: '',
      previewTitle: '',
      currentImageUrl: '',
      imagePreviewList: [],

      // 用于预览的基础url
      base: '',

      // 移交对话框相关
      handoverDialogVisible: false,
      // 移交弹窗：当前项目类型（'代运营' 走不同弹窗内容）
      handoverFormSignType: '',
      handoverForm: {
        projectId: '',
        projectName: '',
        supervisorName: '',
        handoverAt: null,
        conversationId: '', // 选中的企微群ID
        conversationName: '', // 选中的企微群名称（展示用）
        currentBound: false // 该项目是否已绑群（用于显示"换绑"提示）
      },
      // 移交弹窗-企微群下拉
      handoverGroupOptions: [], // [{conversation_id, nickname, total}]
      handoverGroupLoading: false,

      // 修改金额对话框相关
      amountDialogVisible: false,
      amountSubmitting: false,
      amountForm: {
        id: '',
        projectName: '',
        originalAmount: 0,
        totalAmount: 0
      },

      // 解约风险警告弹框相关
      rescindWarnVisible: false,
      rescindCountdown: 0, // 倒计时秒数，>0 时按钮禁用
      rescindTargetRow: null, // 待解约的合同行（确认后跳转用）
      rescindStoreName: '', // 运营中门店名（展示用）
      rescindTimer: null
    }
  },
  computed: {
    confirmHandoverDisabled () {
      if (!this.handoverForm.handoverAt) return true
      if (this.handoverFormSignType !== '代运营' && !this.handoverForm.conversationId) return true
      return false
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    // 财务按钮的显隐依赖 grantedActions（非响应性），监听就位事件触发重算
    this._onGrantedReady = () => { this.grantedTick++ }
    window.addEventListener('grantedActions:ready', this._onGrantedReady)
    this.getAccountInfo()
    this.getEmployeeList()

    // 检查是否有状态参数需要恢复
    const hasStateParams = Object.keys(this.$route.query).some(key =>
      key === 'tabs' || key.startsWith('c') || key.startsWith('p') || key.startsWith('f') || key.startsWith('h')
    )

    if (hasStateParams) {
      // 从URL参数恢复状态
      this.restoreFromParams(this.$route.query)
    }

    // 根据当前tab加载对应数据
    this.loadCurrentTabData()
  },
  beforeDestroy () {
    window.removeEventListener('grantedActions:ready', this._onGrantedReady)
    // 清理解约警告倒计时定时器，防止页面离开后继续计时
    if (this.rescindTimer) {
      clearInterval(this.rescindTimer)
      this.rescindTimer = null
    }
  },

  methods: {

    // 客户年龄标签类型：无身份证（null/undefined）=danger，虚岁>45=warning，否则=success
    customerAgeTagType (age) {
      if (age === null || age === undefined) return 'danger'
      return age > 45 ? 'warning' : 'success'
    },

    // 客户年龄标签文案：无身份证显示"无"，否则显示虚岁数字
    customerAgeTagText (age) {
      if (age === null || age === undefined) return '无'
      return `${age}岁`
    },

    handleTabClick (tab) {
      if (tab.name === 'customer') {
        this.getCustomerList()
      } else if (tab.name === 'project') {
        this.getProjectList()
      } else if (tab.name === 'contract') {
        this.getContractList()
      } else if (tab.name === 'financial') {
        this.getFinancialList()
      }
    },
    // ========== 状态参数相关方法 ==========
    // 生成当前状态的URL参数对象
    buildStateParams () {
      const params = {
        tabs: this.activeTab
      }

      // 根据当前tab保存对应的查询参数
      if (this.activeTab === 'customer') {
        if (this.customerQueryInfo.query) params.cq = this.customerQueryInfo.query
        if (this.customerQueryInfo.from) params.cf = this.customerQueryInfo.from
        if (this.customerQueryInfo.dateArray && this.customerQueryInfo.dateArray.length === 2) {
          params.cds = this.customerQueryInfo.dateArray[0]
          params.cde = this.customerQueryInfo.dateArray[1]
        }
        if (this.customerQueryInfo.creatorId) params.cc = this.customerQueryInfo.creatorId
        params.cpn = this.customerQueryInfo.pagenum
        params.cps = this.customerQueryInfo.pagesize
      } else if (this.activeTab === 'project') {
        if (this.projectQueryInfo.keyword) params.pk = this.projectQueryInfo.keyword
        if (this.projectQueryInfo.signType) params.pst = this.projectQueryInfo.signType
        if (this.projectQueryInfo.signerId) params.psi = this.projectQueryInfo.signerId
        if (this.projectQueryInfo.dateArray && this.projectQueryInfo.dateArray.length === 2) {
          params.pds = this.projectQueryInfo.dateArray[0]
          params.pde = this.projectQueryInfo.dateArray[1]
        }
        params.ppn = this.projectQueryInfo.pagenum
        params.pps = this.projectQueryInfo.pagesize
      } else if (this.activeTab === 'contract') {
        if (this.contractQueryInfo.keyword) params.hk = this.contractQueryInfo.keyword
        if (this.contractQueryInfo.signType) params.hst = this.contractQueryInfo.signType
        if (this.contractQueryInfo.signerId) params.hsi = this.contractQueryInfo.signerId
        if (this.contractQueryInfo.dateArray && this.contractQueryInfo.dateArray.length === 2) {
          params.hds = this.contractQueryInfo.dateArray[0]
          params.hde = this.contractQueryInfo.dateArray[1]
        }
        params.hct = this.contractQueryInfo.contractType
        params.hs = this.contractQueryInfo.status
        params.hpn = this.contractQueryInfo.pagenum
        params.hps = this.contractQueryInfo.pagesize
      } else if (this.activeTab === 'financial') {
        if (this.financialQueryInfo.keyword) params.fk = this.financialQueryInfo.keyword
        if (this.financialQueryInfo.type) params.ft = this.financialQueryInfo.type
        if (this.financialQueryInfo.payType && this.financialQueryInfo.payType.length > 0) {
          params.fpt = this.financialQueryInfo.payType.join(',')
        }
        if (this.financialQueryInfo.feeType) params.fft = this.financialQueryInfo.feeType
        if (this.financialQueryInfo.payAccount) params.fpa = this.financialQueryInfo.payAccount
        if (this.financialQueryInfo.status !== '') params.fs = this.financialQueryInfo.status
        if (this.financialQueryInfo.signerId) params.fsi = this.financialQueryInfo.signerId
        if (this.financialQueryInfo.dateArray && this.financialQueryInfo.dateArray.length === 2) {
          params.fds = this.financialQueryInfo.dateArray[0]
          params.fde = this.financialQueryInfo.dateArray[1]
        }
        params.fpn = this.financialQueryInfo.pagenum
        params.fps = this.financialQueryInfo.pagesize
      }

      return params
    },

    // 从URL参数恢复状态
    restoreFromParams (params) {
      // 恢复tab
      if (params.tabs) {
        this.activeTab = params.tabs
      }

      // 恢复客户列表查询参数
      if (params.cq) this.customerQueryInfo.query = params.cq
      if (params.cf) this.customerQueryInfo.from = params.cf
      if (params.cds && params.cde) {
        this.customerQueryInfo.dateArray = [params.cds, params.cde]
      }
      if (params.cc) this.customerQueryInfo.creatorId = params.cc
      if (params.cpn) this.customerQueryInfo.pagenum = parseInt(params.cpn)
      if (params.cps) this.customerQueryInfo.pagesize = parseInt(params.cps)

      // 恢复项目列表查询参数
      if (params.pk) this.projectQueryInfo.keyword = params.pk
      if (params.pst) this.projectQueryInfo.signType = params.pst
      if (params.psi) this.projectQueryInfo.signerId = params.psi
      if (params.pds && params.pde) {
        this.projectQueryInfo.dateArray = [params.pds, params.pde]
      }
      if (params.ppn) this.projectQueryInfo.pagenum = parseInt(params.ppn)
      if (params.pps) this.projectQueryInfo.pagesize = parseInt(params.pps)

      // 恢复合同列表查询参数
      if (params.hk) this.contractQueryInfo.keyword = params.hk
      if (params.hst) this.contractQueryInfo.signType = params.hst
      if (params.hsi) this.contractQueryInfo.signerId = params.hsi
      if (params.hds && params.hde) {
        this.contractQueryInfo.dateArray = [params.hds, params.hde]
      }
      if (params.hct) this.contractQueryInfo.contractType = params.hct
      if (params.hs !== undefined && params.hs !== '') this.contractQueryInfo.status = parseInt(params.hs)
      if (params.hpn) this.contractQueryInfo.pagenum = parseInt(params.hpn)
      if (params.hps) this.contractQueryInfo.pagesize = parseInt(params.hps)

      // 恢复财务记录查询参数
      if (params.fk) this.financialQueryInfo.keyword = params.fk
      if (params.ft) this.financialQueryInfo.type = parseInt(params.ft)
      if (params.fpt) this.financialQueryInfo.payType = params.fpt.split(',')
      if (params.fft) this.financialQueryInfo.feeType = params.fft
      if (params.fpa) this.financialQueryInfo.payAccount = params.fpa
      if (params.fs !== undefined && params.fs !== '') this.financialQueryInfo.status = parseInt(params.fs)
      if (params.fsi) this.financialQueryInfo.signerId = params.fsi
      if (params.fds && params.fde) {
        this.financialQueryInfo.dateArray = [params.fds, params.fde]
      }
      if (params.fpn) this.financialQueryInfo.pagenum = parseInt(params.fpn)
      if (params.fps) this.financialQueryInfo.pagesize = parseInt(params.fps)

      this.$router.replace({ path: this.$route.path })
    },

    // 根据当前tab加载对应数据
    loadCurrentTabData () {
      if (this.activeTab === 'customer') {
        this.getCustomerList()
      } else if (this.activeTab === 'project') {
        this.getProjectList()
      } else if (this.activeTab === 'financial') {
        this.getFinancialList()
      } else if (this.activeTab === 'contract') {
        this.getContractList()
      }
    },

    // ========== 原有方法 ==========
    // 表格左右滚动
    scrollTable (tableRef, distance) {
      const table = this.$refs[tableRef]
      if (table && table.$el) {
        const scrollBody = table.$el.querySelector('.el-table__body-wrapper')
        if (scrollBody) {
          scrollBody.scrollBy({ left: distance, behavior: 'smooth' })
        }
      }
    },

    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = parseInt(window.sessionStorage.getItem('level'))
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''
    },

    // 财务按钮动作资格（G13）：按登录下发的 grantedActions 判断，替代旧 job==='员工' 猜测。
    // 顺手修正：专员持有「修改收款」无「修改金额」，旧 UI 没禁"改金额"、点了必被后端拒
    finCan (action) {
      const tick = this.grantedTick // 响应性依赖：权限数据就位后重算
      return tick >= 0 && hasAction('zhaoshangCustomer', action)
    },

    // 获取员工列表
    async getEmployeeList () {
      const { data: res } = await this.$http.get('zhaoshang/customer/employees')

      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.employeeList = res.data || []
    },

    // 点击创建人快速筛选
    filterByCreator (row) {
      if (this.activeTab === 'customer') {
        this.customerQueryInfo.creatorId = row.creatorId
        this.getCustomerList(true)
      } else if (this.activeTab === 'project') {
        this.projectQueryInfo.signerId = row.signerId
        this.getProjectList(true)
      } else if (this.activeTab === 'contract') {
        this.contractQueryInfo.signerId = row.signerId
        this.getContractList(true)
      } else if (this.activeTab === 'financial') {
        this.financialQueryInfo.signerId = row.receiverId
        this.getFinancialList(true)
      }
    },

    // 财务列表行级附件合规标识：不合规主款记录浅红底色（与合规检测弹框同一后端口径）
    financialRowClassName ({ row }) {
      return row.complianceReasons && row.complianceReasons.length > 0 ? 'non-compliant-row' : ''
    },

    // 附件不合规行悬停提示文案
    complianceTitle (row) {
      return row.complianceReasons && row.complianceReasons.length > 0
        ? `附件不合规：${row.complianceReasons.join('；')}`
        : ''
    },

    // 点击成交项目跳转收款记录
    filterByProject (row) {
      this.financialQueryInfo.keyword = row.projectName

      this.activeTab = 'financial'
      this.getFinancialList(true)
    },

    // 点击项目合同编号跳转合同列表（按项目精确筛选）
    filterContractByProject (row) {
      this.contractQueryInfo.projectId = row._id
      this.contractQueryInfo.keyword = row.projectName
      this.activeTab = 'contract'
      this.getContractList(true)
    },

    // 重置客户列表搜索
    resetCustomerQuery () {
      this.customerQueryInfo = { query: '', from: '', dateArray: [], creatorId: '', pagenum: 1, pagesize: 10 }
      this.getCustomerList()
    },

    // 重置成交项目搜索
    resetProjectQuery () {
      this.projectQueryInfo = { keyword: '', signType: '', signerId: '', dateArray: [], handoverStatus: '', pagenum: 1, pagesize: 10 }
      this.getProjectList()
    },

    // 重置签约记录搜索
    resetContractQuery () {
      this.contractQueryInfo = { keyword: '', signType: '', signerId: '', dateArray: [], status: '', contractType: '', projectId: '', pagenum: 1, pagesize: 10 }
      this.getContractList()
    },

    // 重置收款记录搜索
    resetFinancialQuery () {
      this.financialQueryInfo = { keyword: '', type: '', payType: [], feeType: '', payAccount: '', status: '', signerId: '', dateArray: [], pagenum: 1, pagesize: 10 }
      this.getFinancialList()
    },

    // 获取客户列表
    async getCustomerList (first = false) {
      first && (this.customerQueryInfo.pagenum = 1) // 三元运算符
      const data = {
        query: this.customerQueryInfo.query,
        from: this.customerQueryInfo.from,
        createDateStart: this.customerQueryInfo.dateArray?.[0] || '',
        createDateEnd: this.customerQueryInfo.dateArray?.[1] || '',
        creatorId: this.customerQueryInfo.creatorId,
        pagenum: this.customerQueryInfo.pagenum,
        pagesize: this.customerQueryInfo.pagesize
      }
      const { data: res } = await this.$http.get('zhaoshang/customer/list', { params: data })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.customerList = res.data.list
      this.customerTotal = res.data.total
    },

    // 监听pagesize改变的事件
    customerHandleSizeChange (newSize) {
      this.customerQueryInfo.pagesize = newSize
      this.getCustomerList()
    },

    // 监听页码改变
    customerHandleCurrentChange (newPage) {
      this.customerQueryInfo.pagenum = newPage
      this.getCustomerList()
    },

    // 获取项目列表
    async getProjectList (first = false) {
      first && (this.projectQueryInfo.pagenum = 1) // 三元运算符
      const data = {
        keyword: this.projectQueryInfo.keyword,
        signType: this.projectQueryInfo.signType,
        signerId: this.projectQueryInfo.signerId,
        dealDateStart: this.projectQueryInfo.dateArray?.[0] || '',
        dealDateEnd: this.projectQueryInfo.dateArray?.[1] || '',
        handoverStatus: this.projectQueryInfo.handoverStatus,
        pagenum: this.projectQueryInfo.pagenum,
        pagesize: this.projectQueryInfo.pagesize
      }
      const { data: res } = await this.$http.get('zhaoshang/project/list', { params: data })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.projectList = res.data.list
      this.projectTotal = res.data.total
    },

    // 监听门店pagesize改变
    projectHandleSizeChange (newSize) {
      this.projectQueryInfo.pagesize = newSize
      this.getProjectList()
    },
    // 监听门店页码改变
    projectHandleCurrentChange (newPage) {
      this.projectQueryInfo.pagenum = newPage
      this.getProjectList()
    },

    // 获取财务列表
    async getFinancialList (first = false) {
      first && (this.financialQueryInfo.pagenum = 1) // 三元运算符
      const data = {
        keyword: this.financialQueryInfo.keyword,
        type: this.financialQueryInfo.type,
        payType: this.financialQueryInfo.payType.length > 0 ? this.financialQueryInfo.payType.join(',') : '',
        feeType: this.financialQueryInfo.feeType,
        payAccount: this.financialQueryInfo.payAccount,
        status: this.financialQueryInfo.status,
        signerId: this.financialQueryInfo.signerId, // 签约人ID
        payDateStart: this.financialQueryInfo.dateArray?.[0] || '',
        payDateEnd: this.financialQueryInfo.dateArray?.[1] || '',
        pagenum: this.financialQueryInfo.pagenum,
        pagesize: this.financialQueryInfo.pagesize
      }
      try {
        const { data: res } = await this.$http.get('zhaoshang/customerBill/list', { params: data })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.financialList = res.data.list
        this.financialTotal = res.data.total
        this.financialSummary = res.data.summary || {
          incomeCount: 0,
          incomeAmount: 0,
          refundCount: 0,
          refundAmount: 0
        }
      } catch (error) {
        this.$message.error('获取财务记录列表失败')
      }
    },

    // 格式化金额为千分位 + 两位小数
    formatMoney (amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    // 监听财务pagesize改变
    financialHandleSizeChange (newSize) {
      this.financialQueryInfo.pagesize = newSize

      this.getFinancialList()
    },
    // 监听财务页码改变
    financialHandleCurrentChange (newPage) {
      this.financialQueryInfo.pagenum = newPage
      this.getFinancialList()
    },

    // 点击修改按钮
    async modifyClickHandler (row) {
      const stateParams = this.buildStateParams()
      this.$router.push({
        path: `/zhaoshang/customer/modify/${row._id}`,
        query: stateParams
      })
    },

    // 删除二次确认：要求用户输入指定文字
    async confirmDeleteAction (inputTip) {
      const promptResult = await this.$prompt(
        `请输入“${inputTip}”以确认此操作`,
        '二次确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: new RegExp('^' + inputTip + '$'),
          inputErrorMessage: `请输入“${inputTip}”`
        }
      ).catch((err) => err)

      // $prompt 确认时返回 { value, action: 'confirm' }，取消/关闭时返回 'cancel'/'close'
      if (!promptResult || promptResult.action !== 'confirm') {
        this.$message.info('操作已经取消')
        return false
      }
      return true
    },

    // 删除原因（必填，操作日志强制留痕）：返回原因字符串；取消返回 false
    async promptDeleteReason (label) {
      const result = await this.$prompt(
        `请输入删除该${label}的原因（必填，将记入操作日志）`,
        '删除原因',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '例如：客户重复录入，保留另一条',
          inputValidator: v => !!(v && v.trim()) || '删除原因不能为空'
        }
      ).catch((err) => err)

      if (!result || result.action !== 'confirm') {
        this.$message.info('操作已经取消')
        return false
      }
      return result.value.trim()
    },

    // 点击删除按钮
    async deleteClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除该客户吗？',
        '删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      // 删除原因必填（操作日志强制留痕）
      const reason4Customer = await this.promptDeleteReason('客户')
      if (reason4Customer === false) return

      try {
        const { data: res } = await this.$http.delete(`zhaoshang/customer/remove/${row._id}`, { params: { reason: reason4Customer } })

        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.getCustomerList()
      } catch (error) {
        this.$message.error('删除失败')
      }
    },

    // 点击添加客户按钮
    createCustomerClickHandler () {
      this.$router.push('/zhaoshang/customer/add')
    },

    // 新增成交项目
    createProjectClickHandler (row) {
      const stateParams = this.buildStateParams()
      // 跳转到门店新增页面，并传递客户ID
      this.$router.push({
        path: '/zhaoshang/project/add',
        query: { customerId: row._id, customerName: encodeURIComponent(row.title), signerId: row.creatorId, signerName: encodeURIComponent(row.creatorName), ...stateParams }
      })
    },

    // 新增收款-尾款（从项目列表点击）
    createAddIncomeHandler (row) {
      const stateParams = this.buildStateParams()
      // 跳转到收款新增页面，并传递项目ID
      this.$router.push({
        path: '/zhaoshang/financial/addIncome',
        query: { contractId: row._id, ...stateParams }
      })
    },

    // 新增收款-续签（从项目列表点击）
    createAddReIncomeHandler (row) {
      const stateParams = this.buildStateParams()
      // 跳转到收款新增页面，并传递项目ID
      this.$router.push({
        path: '/zhaoshang/financial/addReIncome',
        query: { customerName: encodeURIComponent(row.customerName), projectId: row._id, projectName: encodeURIComponent(row.projectName), ...stateParams }
      })
    },

    // 新增退款（解约）——先检查项目是否有运营中门店，有则弹出醒目警告
    async createAddRefundHandler (row) {
      try {
        const { data: res } = await this.$http.get(`zhaoshang/contract/operating-store-check/${row.projectId}`)
        // 后端应用层错误也以 HTTP200 返回（错误在 meta.status），无论接口故障还是网络异常都降级放行，
        // 不因检查故障阻塞解约业务
        if (res.meta.status !== 200) {
          console.warn('[解约前运营检查] 接口返回异常，已放行跳转:', res.meta.msg)
          return this.goAddRefund(row)
        }
        if (res.data && res.data.operating) {
          this.rescindTargetRow = row
          this.rescindStoreName = res.data.storeName || ''
          this.showRescindWarn()
          return
        }
      } catch (error) {
        console.warn('[解约前运营检查] 接口异常，已放行跳转:', error && error.message)
      }
      this.goAddRefund(row)
    },

    // 跳转解约页面
    goAddRefund (row) {
      const stateParams = this.buildStateParams()
      // 跳转到收款新增页面，并传递项目ID
      this.$router.push({
        path: '/zhaoshang/financial/addRefund',
        query: { contractId: row._id, ...stateParams }
      })
    },

    // 打开解约风险警告弹框并启动30秒倒计时
    showRescindWarn () {
      // 防重复开启叠加定时器
      if (this.rescindTimer) {
        clearInterval(this.rescindTimer)
        this.rescindTimer = null
      }
      this.rescindCountdown = 30
      this.rescindWarnVisible = true
      this.rescindTimer = setInterval(() => {
        this.rescindCountdown--
        if (this.rescindCountdown <= 0) {
          clearInterval(this.rescindTimer)
          this.rescindTimer = null
        }
      }, 1000)
    },

    // 警告弹框-倒计时结束后确认进入解约页面
    confirmRescind () {
      this.closeRescindWarn()
      if (this.rescindTargetRow) this.goAddRefund(this.rescindTargetRow)
    },

    // 关闭警告弹框（清理倒计时）
    closeRescindWarn () {
      if (this.rescindTimer) {
        clearInterval(this.rescindTimer)
        this.rescindTimer = null
      }
      this.rescindWarnVisible = false
    },

    // 修改合同
    async modifyContract (row) {
      const stateParams = this.buildStateParams()
      this.$router.push({
        path: `/zhaoshang/contract/modify/${row._id}`,
        query: { contractId: row._id, ...stateParams }
      })
    },

    // 修改财务记录
    modifyFinancialClickHandler (row) {
      if (row.status === 1) {
        return this.$message.error('该财务记录已完成审核，不能修改！')
      }
      const stateParams = this.buildStateParams()
      if (row.type === 1) {
        this.$router.push({
          path: `/zhaoshang/financial/modifyIncome/${row._id}`,
          query: stateParams
        })
      } else {
        this.$router.push({
          path: `/zhaoshang/financial/modifyRefund/${row._id}`,
          query: stateParams
        })
      }
    },

    // 打开修改金额对话框
    openAmountDialog (row) {
      if (row.status === 1) {
        return this.$message.error('该财务记录已审核，请先取消审核再修改金额')
      }
      this.amountForm.id = row._id
      this.amountForm.projectName = row.projectName
      this.amountForm.originalAmount = row.totalAmount
      this.amountForm.totalAmount = row.totalAmount
      this.amountDialogVisible = true
    },

    // 提交金额修改
    async submitAmountModify () {
      if (!this.amountForm.totalAmount || this.amountForm.totalAmount <= 0) {
        return this.$message.error('金额必须大于0')
      }
      this.amountSubmitting = true
      try {
        const { data: res } = await this.$http.put(`zhaoshang/customerBill/modifyAmount/${this.amountForm.id}`, {
          totalAmount: this.amountForm.totalAmount
        })
        if (res.meta.status !== 200) {
          this.amountSubmitting = false
          return this.$message.error(res.meta.msg)
        }
        this.$message.success(res.meta.msg)
        this.amountDialogVisible = false
        this.amountSubmitting = false
        this.getFinancialList()
      } catch (error) {
        this.amountSubmitting = false
        this.$message.error('修改金额失败')
      }
    },

    // 删除财务记录
    async deleteFinancialClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除该财务记录吗？',
        '删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      // 删除原因必填（操作日志强制留痕）
      const reason4Bill = await this.promptDeleteReason('财务记录')
      if (reason4Bill === false) return

      try {
        const { data: res } = await this.$http.delete(`zhaoshang/customerBill/remove/${row._id}`, { params: { reason: reason4Bill } })

        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.getFinancialList()
      } catch (error) {
        this.$message.error('删除失败')
      }
    },

    // 修改项目（从项目列表点击）
    modifyProjectClickHandler (row) {
      const stateParams = this.buildStateParams()
      this.$router.push({
        path: `/zhaoshang/project/modify/${row._id}`,
        query: stateParams
      })
    },

    isTransferredOldProject (row) {
      return !!(row && row.transferOutInfo && row.transferOutInfo.toProjectId)
    },

    isTransferredInProject (row) {
      return !!(row && row.transferInInfo && row.transferInInfo.fromProjectId)
    },

    transferOutTooltip (info) {
      if (!info) return ''
      let date = ''
      if (info.transferDate) {
        const d = new Date(info.transferDate)
        if (!isNaN(d.getTime())) {
          date = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        }
      }
      const target = `${info.toCustomerName || '-'} / ${info.toProjectName || '-'}`
      return `转让至：${target}${date ? `（${date}）` : ''}`
    },

    async modifyTransferRemarkHandler (row) {
      try {
        const { value } = await this.$prompt('请输入备注', '修改备注', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValue: row.remark || '',
          inputValidator: v => (v || '').length <= 500 || '备注不能超过500个字符'
        })
        const { data: res } = await this.$http.put(`zhaoshang/project/modifyRemark/${row._id}`, { remark: value || '' })
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('备注修改成功')
        this.getProjectList()
      } catch (error) {
        // 取消
      }
    },

    // 获取文件完整URL
    getFileUrl (url) {
      if (!url) return ''
      return this.base + url
    },

    // 预览附件
    handlePreviewAttachment (file) {
      if (!file) return

      const fileUrl = this.getFileUrl(file.url)
      this.previewTitle = file.name || '附件预览'

      if (file.type === 'image') {
        // 构建当前财务记录的所有图片列表用于预览
        this.imagePreviewList = [fileUrl]
        this.currentImageUrl = fileUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      } else if (file.type === 'pdf') {
        // PDF使用对话框预览
        this.previewUrl = fileUrl
        this.pdfPreviewDialogVisible = true
      } else {
        this.$message.info('不支持预览该文件类型')
      }
    },

    // 删除项目（从项目列表点击）
    async deleteProjectClickHandler (row) {
      const confirmResult = await this.$confirm(
        '确定要删除该项目吗？',
        '删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      // 删除原因必填（操作日志强制留痕）
      const reason4Project = await this.promptDeleteReason('项目')
      if (reason4Project === false) return

      try {
        const { data: res } = await this.$http.delete(`zhaoshang/project/remove/${row._id}`, { params: { reason: reason4Project } })

        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.getProjectList()
      } catch (error) {
        this.$message.error('删除失败')
      }
    },

    getMultLine (value) {
      if (value === null || value === undefined || value === '') return '--'
      // 先转义再换行：值来自表单录入，防止 v-html 渲染注入的 HTML
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .split('\n')
        .join('<br>')
    },

    // 平台代码 -> 中文名称
    platformName (p) {
      return { meituan: '美团', eleme: '饿了么', jd: '京东' }[p] || p
    },

    // 项目移交按钮是否禁用（代运营分支）
    getHandoverDisabled (row) {
      if (row.signType === '其他') return true
      if (row.signType === '代运营') {
        // 代运营：无服务期记录时可移交
        return !!row.proxyStatus
      }
      // 品牌项目：原逻辑 AND 已录入门店（hasStore）无需再走移交
      return !row.supervisorId || !row.storeMap || row.storeMap.flag < 1 || row.handoverStatus >= 1 || row.hasStore
    },

    // 撤回移交按钮是否禁用（代运营分支）
    getCancelHandoverDisabled (row) {
      if (row.signType === '其他') return true
      if (row.signType === '代运营') {
        // 代运营：仅 initial+PENDING 可撤回；前端宽松判断（精确判断由后端完成）
        // renewal 来源的 PENDING 后端会拒绝，前端给出友好提示
        return row.proxyStatus !== 'PENDING'
      }
      // 品牌项目：原逻辑 AND 已录入门店（hasStore）无移交记录可撤回
      return !row.supervisorId || !row.storeMap || row.storeMap.flag < 1 || row.handoverStatus >= 2 || row.hasStore
    },

    // 项目转让按钮是否禁用
    // 运营中/筹建中/待运营可转让；代运营、其他、已终止/闭店等不可转让
    getTransferDisabled (row) {
      if (row.signType === '代运营' || row.signType === '其他') return true
      if (row.transferOutInfo && row.transferOutInfo.toProjectId) return true
      // storeMap 缺失时项目列表会补一个无 _id 的默认对象，不能只判断 flag
      if (!row.storeMap || !row.storeMap._id || !(row.storeMap.flag >= 1)) return true
      if (!['运营中', '筹建中', '待运营'].includes(row.storeStatus)) return true
      return false
    },

    // 项目转让：预检筹建督导后跳转转让页面（无督导则转让流程无处指派且事后无法补建，直接拦截）
    async transferProjectClickHandler (row) {
      if (this.transferCheckingId) return
      this.transferCheckingId = row._id
      try {
        const { data: res } = await this.$http.get(`zhaoshang/project/transferInit/${row._id}`)
        if (res.meta.status !== 200) {
          this.$message.error(res.meta.msg)
          return
        }
        if (res.data.transferMode === 'unavailable') {
          this.$message.error('当前项目或门店状态不可转让')
          return
        }
        if (res.data.supervisorInactive) {
          this.$message.error('老项目督导已离职，请先更换督导后再转让')
          return
        }
        if (!res.data.constructionSupervisor) {
          this.$message.error('老项目无有效筹建督导，无法转让，请先为项目门店分配筹建督导')
          return
        }
        if (res.data.transferMode === 'building' && !res.data.buildFlow) {
          const msg = res.data.store && res.data.store.status === '待运营'
            ? '筹建流程已完成，请走运营转让或联系管理员处理'
            : '老项目无进行中的筹建流程，无法转让'
          this.$message.error(msg)
          return
        }
        this.$router.push({
          path: '/zhaoshang/project/transfer',
          query: { oldProjectId: row._id }
        })
      } catch (error) {
        this.$message.error('检查项目转让条件失败')
      } finally {
        this.transferCheckingId = ''
      }
    },

    // 打开移交对话框
    async handoverProjectClickHandler (row) {
      // 代运营项目：不需要督导，打开代运营专用弹窗内容
      if (row.signType === '代运营') {
        this.handoverFormSignType = '代运营'
        this.handoverForm = {
          projectId: row._id,
          projectName: row.projectName,
          packageType: '',
          estimatedVolumes: [
            { platform: 'meituan', volume: null },
            { platform: 'eleme', volume: null },
            { platform: 'jd', volume: null }
          ],
          handoverAt: this.formatDateTime(new Date()),
          handoverRemark: ''
        }
        this.handoverDialogVisible = true
        return
      }

      // 品牌项目：原逻辑
      this.handoverFormSignType = row.signType
      if (!row.supervisorId) {
        return this.$message.warning('请先为项目指定督导')
      }

      // 设置表单数据，移交时间默认为当前时间
      this.handoverForm = {
        projectId: row._id,
        projectName: row.projectName,
        supervisorName: row.supervisorName,
        handoverAt: this.formatDateTime(new Date()),
        conversationId: '',
        conversationName: '',
        currentBound: false
      }
      this.handoverGroupOptions = []

      // 预填：查询该项目已绑的群（如有），并加载初始群列表
      try {
        const { data: res } = await this.$http.get(`zhaoshang/project/handoverBindInfo/${row._id}`)
        if (res.meta.status === 200 && res.data.conversationId) {
          this.handoverForm.conversationId = res.data.conversationId
          this.handoverForm.conversationName = res.data.groupNickname
          this.handoverForm.currentBound = true
          // 把已绑群塞进 options，保证 el-select 能回显 label
          this.handoverGroupOptions = [{
            conversation_id: res.data.conversationId,
            nickname: res.data.groupNickname,
            total: 0
          }]
        }
      } catch (e) {
        // 预填失败不阻断流程
      }

      // 同时加载一份初始群列表，供用户直接选择/搜索
      this.searchHandoverGroups('')

      this.handoverDialogVisible = true
    },

    // 远程搜索企微群（移交弹窗用，复用项目移交权限的接口）
    async searchHandoverGroups (query) {
      this.handoverGroupLoading = true
      try {
        const { data: res } = await this.$http.get('zhaoshang/project/handoverGroups', { params: { keyword: query } })
        if (res.meta.status === 200) {
          const list = res.data.list || []
          // 若已预填的群不在搜索结果里，补进 options 避免回显丢失
          if (this.handoverForm.conversationId && !list.some(g => g.conversation_id === this.handoverForm.conversationId)) {
            list.unshift({
              conversation_id: this.handoverForm.conversationId,
              nickname: this.handoverForm.conversationName,
              total: 0
            })
          }
          this.handoverGroupOptions = list
        }
      } catch (e) {
        // 忽略，保留现有 options
      } finally {
        this.handoverGroupLoading = false
      }
    },

    // 企微群选中变化时，同步名称（用于回显兜底）
    onHandoverGroupChange (val) {
      const item = this.handoverGroupOptions.find(g => g.conversation_id === val)
      this.handoverForm.conversationName = item ? item.nickname : ''
    },

    // 格式化日期时间为 yyyy-MM-dd HH:mm:ss
    formatDateTime (date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      const h = String(date.getHours()).padStart(2, '0')
      const min = String(date.getMinutes()).padStart(2, '0')
      const s = String(date.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // 确认移交
    async confirmHandover () {
      // 代运营项目：不校验企微群
      if (this.handoverFormSignType !== '代运营') {
        if (!this.handoverForm.conversationId) {
          return this.$message.warning('请选择企微群')
        }
      }
      if (!this.handoverForm.handoverAt) {
        return this.$message.warning('请选择移交时间')
      }

      // 代运营项目提交
      if (this.handoverFormSignType === '代运营') {
        const estimatedVolumes = (this.handoverForm.estimatedVolumes || [])
          .filter(v => v.volume != null && v.volume !== '')
        try {
          const { data: res } = await this.$http.post(
            `zhaoshang/project/handover/${this.handoverForm.projectId}`,
            {
              handoverAt: this.handoverForm.handoverAt,
              conversationId: '',
              packageType: this.handoverForm.packageType,
              estimatedVolumes
            }
          )
          if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
          this.$message.success('代运营项目移交成功')
          this.handoverDialogVisible = false
          this.getProjectList()
        } catch (error) {
          this.$message.error('移交失败')
        }
        return
      }

      // 品牌项目：原逻辑
      try {
        const { data: res } = await this.$http.post(
          `zhaoshang/project/handover/${this.handoverForm.projectId}`,
          {
            handoverAt: this.handoverForm.handoverAt,
            conversationId: this.handoverForm.conversationId
          }
        )
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)

        // 后端返回 handoverBound:false 表示移交成功但绑群失败，给出分级提示
        if (res.data && res.data.handoverBound === false) {
          this.$message.warning(res.meta.msg)
        } else {
          this.$message.success('移交并绑定群成功')
        }
        this.handoverDialogVisible = false
        this.getProjectList()
      } catch (error) {
        this.$message.error('移交失败')
      }
    },

    // 撤回移交
    async cancelHandoverClickHandler (row) {
      const confirmResult = await this.$confirm(
        `确定要撤回项目"${row.projectName}"的移交吗？`,
        '撤回确认',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已取消')

      try {
        const { data: res } = await this.$http.post(`zhaoshang/project/handoverCancel/${row._id}`)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success('撤回成功')
        this.getProjectList()
      } catch (error) {
        this.$message.error('撤回失败')
      }
    },

    // 获取合同列表
    async getContractList (first = false) {
      first && (this.contractQueryInfo.pagenum = 1)

      const data = {
        keyword: this.contractQueryInfo.keyword,
        signType: this.contractQueryInfo.signType,
        signerId: this.contractQueryInfo.signerId,
        dealDateStart: this.contractQueryInfo.dateArray?.[0] || '',
        dealDateEnd: this.contractQueryInfo.dateArray?.[1] || '',
        contractType: this.contractQueryInfo.contractType,
        status: this.contractQueryInfo.status === 'transfer' ? -1 : this.contractQueryInfo.status,
        rescindType: this.contractQueryInfo.status === 'transfer'
          ? 'transfer'
          : (this.contractQueryInfo.status === -1 ? 'normal' : ''),
        projectId: this.contractQueryInfo.projectId || '',
        pagenum: this.contractQueryInfo.pagenum,
        pagesize: this.contractQueryInfo.pagesize
      }

      const { data: res } = await this.$http.get('zhaoshang/contract/list', { params: data })
      if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
      this.contractList = res.data.list
      this.contractTotal = res.data.total
    },

    // 监听合同pagesize改变
    contractHandleSizeChange (newSize) {
      this.contractQueryInfo.pagesize = newSize
      this.getContractList()
    },
    // 监听合同页码改变
    contractHandleCurrentChange (newPage) {
      this.contractQueryInfo.pagenum = newPage
      this.getContractList()
    },

    // 删除合同
    async deleteContract (row) {
      const confirmResult = await this.$confirm(
        '确定要删除该合同吗？此操作将删除该合同的所有财务记录。',
        '删除',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch((err) => err)

      if (confirmResult === 'cancel') return this.$message.info('操作已经取消')

      // 删除原因必填（操作日志强制留痕）
      const reason4Contract = await this.promptDeleteReason('合同')
      if (reason4Contract === false) return

      try {
        const { data: res } = await this.$http.delete(`zhaoshang/contract/remove/${row._id}`, { params: { reason: reason4Contract } })

        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.getContractList()
      } catch (error) {
        this.$message.error('删除失败')
      }
    }
  }
}
</script>

<style lang="less">
/* 财务列表附件不合规行浅红底色（含 hover 保持浅红系） */
.el-table .non-compliant-row td {
  background-color: #fef0f0;
}
.el-table--enable-row-hover .el-table__body tr.non-compliant-row:hover > td {
  background-color: #fde2e2;
}

.page-area{
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin-top:5px;
  margin-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;

  .summary-text{
    font-size:14px;
    font-weight: bold;
  }

  .el-pagination{
    margin-top:0px;
  }

}

.no-padding{
  .el-tabs__content{
    padding: 0!important;
  }
}

</style>

<style lang="less" scoped>
.search-bar{
  margin-bottom: 10px;
  border-radius: 4px;
  padding:20px;
  padding-bottom: 0;
  background-color:#f5f7fa;
}
.text-title{
  font-size: 14px;
  font-weight: bold;
  color: #191a1a;
}
.text-content{
  font-size: 12px;
  color: #909399;
}
.bold{
  font-weight: bold;
}
.black{
  color: #000000;
}
.red{
  color: #FF4D4F;
}
.green{
  color: #67C23A;
}
.blue{
  color: #409EFF;
}
.delete-line{
  text-decoration: line-through;
}

.text-detail{
  font-size: 12px;
  color: #909399;
}
.table-header-with-arrows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.arrow-buttons {
  display: flex;
  gap: 8px;
  margin-left: 10px;
}
.arrow-buttons i {
  cursor: pointer;
  font-size: 16px;
  color: #409EFF;
  transition: all 0.3s;
  padding: 2px 4px;
  border-radius: 4px;
}
.arrow-buttons i:hover {
  background-color: #ecf5ff;
  transform: scale(1.2);
}
.arrow-buttons i:active {
  transform: scale(0.95);
}

.btn-container{
  display: flex;
  flex-wrap: wrap;
  // justify-content:space-between;
  gap: 10px;

  .el-button+.el-button{
    margin-left: 0;
  }
}

// 解约风险警告弹框
.rescind-warn-body {
  text-align: center;
  padding: 10px 0 0;
}
.rescind-warn-icon {
  display: block;
  font-size: 80px;
  color: #F56C6C;
  margin-bottom: 16px;
}
.rescind-warn-text {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  line-height: 1.6;
}
.rescind-warn-strong {
  color: #F56C6C;
}
.rescind-warn-store {
  margin-top: 8px;
  font-size: 14px;
  color: #909399;
}
</style>
